module.exports = __webpack_public_path__ + "static/media/star-2.64a3732a.svg";